import Icon from '../components/Icon.vue'

Icon.register({
  dumbbell: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M104 96c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-104h-24c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h24v-104c0-13.3 10.7-24 24-24h48zM632 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-24v104c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-272c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v104h24zM456 32c13.3 0 24 10.7 24 24v400c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-168h-128v168c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-400c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v168h128v-168c0-13.3 10.7-24 24-24h48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dumbbell.js
// module id = 1291
// module chunks = 0